import { useMutation, useQueryClient } from '@tanstack/react-query';
import { BASE_URL } from '../../../../../utils/Constants';
import { useAuthStore } from '../../../../../utils/stores/useAuthStore';
import { VenereChatSession } from '../types/VenereChatSession';

const createVenereSession = async ({
  user_id,
  expertId,
  expertType,
  idToken,
}: {
  user_id: string;
  expertId: string;
  expertType: string;
  idToken: string;
}) => {
  
  const response = await fetch(`${BASE_URL}/api/chat/sessions`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'http://localhost:3000',
      'Authorization': idToken,
    },
    body: JSON.stringify({
      user_id,
      expert_id: expertId,
      expert_type: expertType,
    }),
  });

  if (!response.ok) {
    throw new Error('Failed to create chat session');
  }
  
  const data = await response.json();
  return data as VenereChatSession;
};

export const useVenereCreateSession = (expertId: string, expertType: string) => {
  const { auth } = useAuthStore();
  const userId = auth.userId;
  const idToken = auth.idToken;
  const queryClient = useQueryClient();
  
  const { mutate, isPending, data, isError, isSuccess } = useMutation({
    mutationFn: () =>
      createVenereSession({
        user_id: userId!,
        expertId: expertId,
        expertType: expertType,
        idToken: idToken!,
      }),
    onSuccess: () => {
      // Invalidate Venere-specific queries
      queryClient.invalidateQueries({ queryKey: ['venereChatSessions'] });
    },
  });

  return { mutate, isPending, data, isError, isSuccess };
}; 